import { urlConfig } from 'config/url.config'
import { RequireAuth } from 'modules/user/hoc/require-auth'
import { ThrowAuth } from 'modules/user/hoc/throw-auth'
import { UserRole } from 'modules/user/schemas/user.schema'
import { DashboardPage } from 'pages/dashboard-page'
import { DetailsPage } from 'pages/details-page'
import { LoginPage } from 'pages/login-page'
import { LogsPage } from 'pages/logs-page'
import { ManageUsersPage } from 'pages/manage-users-page'
import { NotFoundPage } from 'pages/not-found-page'
import { memo } from 'react'
import { Outlet, useRoutes } from 'react-router-dom'

interface RoutesProps {}
export const Routes: React.FC<RoutesProps> = memo(() => {
    return useRoutes([
        // auth required
        {
            path: urlConfig.pages.main,
            element: (
                <RequireAuth>
                    <Outlet />
                </RequireAuth>
            ),
            children: [
                {
                    path: urlConfig.pages.dashboard,
                    element: <DashboardPage />,
                },
                {
                    path: urlConfig.pages.detailsId,
                    element: <DetailsPage />,
                },
                {
                    path: urlConfig.pages.logs,
                    element: <LogsPage />,
                },
                {
                    path: urlConfig.pages.manageUsers,
                    element: (
                        <RequireAuth allowedRoles={[UserRole.SUPERADMIN]}>
                            <ManageUsersPage />
                        </RequireAuth>
                    ),
                },
            ],
        },
        // no auth required
        {
            path: urlConfig.pages.login,
            element: (
                <ThrowAuth callbackPath={urlConfig.pages.main}>
                    <LoginPage />
                </ThrowAuth>
            ),
        },
        //
        {
            path: '*',
            element: <NotFoundPage />,
        },
    ])
})
Routes.displayName = 'Routes'
